import React, { useMemo, } from 'react';

import {
    Btn,
    Box,
    Container,
    H2,
    P,
} from '@saladbob/sassafras'


import divisionLabels, { divisionColors, genderLabels, topLabels } from '../../data/divisionLabels';

import { useTeam } from '../providers/TeamProvider';

type DivisionOptions = {
    label: string;
    color?: string;
    txtColor?: string;
    value: string;
    coed?: boolean;
    minAge?: number;
    maxAge?: number;
};

type Props = {
    divisions: DivisionOptions[]
    onSubmit: (division: string) => void;
    onExit: () => void;
    children: React.ReactNode;
};

const SpecialDivision: React.FC<Props> = ({ divisions, onSubmit, children }) => {
    const { ageDivision, genderDivision, minA, maxA } = useTeam();
    const divisionLabel = useMemo(() => {
        return `${genderLabels[genderDivision]} ${divisionLabels[Number(ageDivision) - 1]}`;
    }, [ageDivision, genderDivision]);

    const options = useMemo(() => {
        // Create default division option
        const opts: DivisionOptions[] = [{
            label: maxA < 9 ? 'Minny Macker (8 and Under)' : 'Regular Division',
            value: divisionLabels[ageDivision - 1],
            color: divisionColors[ageDivision - 1],
            txtColor: ageDivision < 6 ? 'white' : 'black',
        }];
    
        // Add top courts if adult team.
        if (ageDivision && Number(ageDivision) > 5) {
            const label = `Top ${topLabels[genderDivision]}`;
            opts.push({
                label: `Top ${topLabels[genderDivision]}`,
                value: label,
                color: 'secondary',
                txtColor: 'white',
            });
        }
        if (divisions) {
            opts.push(...divisions.reduce((acc, division) => {
                // Check if age range is within division's range
                if (division.maxAge && maxA > division.maxAge) return acc;
                if (division.minAge && minA < division.minAge) return acc;

                const label = `${division.coed ? '' : `${genderLabels[genderDivision]} `}${division.label}`;

                acc.push({
                    ...division,
                    label,
                    value: label,
                });
                return acc;
            }, []));
        }
        return opts;
    }, [minA, maxA, divisions, ageDivision, genderDivision]);

    return (
        <Container>
            {divisions && (
                <Box pt="lg">
                    <H2 align="center" mb="lg">Special Division</H2>
                    <Box display="flex" wrap="wrap" justify="center" align="center" mb="lg">
                        {options.map((division) => (
                            <Box padding="xs" minWidth="max-content" maxWidth="300px">
                                <Btn
                                    key={division.value}
                                    onClick={() => onSubmit(division.value)}
                                    color={division.color}
                                    txtColor={division.txtColor}
                                    full
                                >
                                        {division.label}
                                </Btn>
                            </Box>
                        ))}
                    </Box>
                </Box>
            )}
            {children}
        </Container>
    );
}

export default SpecialDivision;
